import React from 'react';
import moment from 'moment';
import ListarDatos from '../../../../general/ListarDatos';
import { COLORES_ESTADO } from '../../../helper';

const DEFAULT_AVATAR = { backgroundColor: '#B8B8B8', color: '#D9D7D7' };

function DetalleEstadosTab({ estados }) {
    return (
        <ListarDatos
            datos={estados}
            id='tbl_estados_bienestar'
            avatar={({ tipo_estado }) => tipo_estado.nombre.charAt(0).toUpperCase()}
            color_avatar={({ tipo_estado }) => COLORES_ESTADO[tipo_estado.codigo] || DEFAULT_AVATAR}
            fila_principal={({ tipo_estado }) => tipo_estado.nombre.toUpperCase()}
            filas={[
                { id: 'usuario_registro', mostrar: ({ usuario_registro: { primer_nombre, primer_apellido, segundo_apellido } }) => `${primer_nombre} ${primer_apellido} ${segundo_apellido}` },
                { id: 'mensaje', mostrar: ({ mensaje }) => mensaje ? mensaje : '' },
                { id: 'fecha_registro', mostrar: ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a'), nombre: 'Fecha Registro : ' },
            ]}
        />
    );
}

export default React.memo(DetalleEstadosTab);
